import clsx from "clsx";

interface AvatarProps {
    name: string;
    src?: string | null;
    size?: "sm" | "md" | "lg" | "xl";
    className?: string;
}

const SIZES = {
    sm: "h-8 w-8 text-xs",
    md: "h-10 w-10 text-sm",
    lg: "h-14 w-14 text-lg",
    xl: "h-20 w-20 text-2xl",
};

function initials(name: string): string {
    return name
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase() ?? "")
        .join("");
}

export function Avatar({ name, src, size = "md", className }: AvatarProps) {
    return (
        <div
            className={clsx(
                "flex shrink-0 items-center justify-center overflow-hidden rounded-full font-bold text-white",
                "bg-gradient-to-br from-[var(--color-primary)] to-[var(--app-accent-text)]",
                SIZES[size],
                className,
            )}
        >
            {src ? (
                <img src={src} alt={name} className="h-full w-full object-cover" />
            ) : (
                initials(name || "?")
            )}
        </div>
    );
}
